// Visibilité d'une entrée de menu pilotée par une clé de `feature_flags` en lecture STRICTE.
// `isFeatureEnabled` (PermissionContext) rend true quand la clé est ABSENTE ; ici seul un
// true explicite ouvre. Contexte non chargé => fermé (jamais d'entrée qui apparaît puis disparaît).
// Masquer une entrée n'autorise ni n'interdit rien : l'autorité reste côté serveur.
export function featureAccordee(permissionContext, featureId) {
  if (!permissionContext || !featureId) return false;
  if (permissionContext.is_super_admin) return true;
  return (permissionContext.feature_flags || {})[featureId] === true;
}

// Variante SANS contournement : le contexte serveur d'un super-admin HORS aperçu vaut « toutes les clés du
// catalogue à true » (authorization_engine._get_all_feature_flags_enabled) : il ne dit RIEN du tenant
// affiché. Pour ce cas seul, la décision se lit sur les flags BRUTS du tenant actif (`flagsBrutsTenant`,
// jamais chargés => fermé). Aperçu et non super-admin : `feature_flags` du contexte = flags du tenant.
// Sert aux entrées dont la présence est un choix MÉTIER du tenant (menu « Clients » de Mario).
// Masquer n'autorise ni n'interdit rien : l'autorité reste serveur.
export function featureExacte(permissionContext, featureId, flagsBrutsTenant) {
  if (!permissionContext || !featureId) return false;
  const source = permissionContext.is_super_admin && !permissionContext.apercu
    ? flagsBrutsTenant
    : permissionContext.feature_flags;
  return (source || {})[featureId] === true;
}
